import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Tooltip, Box } from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import GraphTable from "./GraphTable";
import { exportBreakdownRows } from "./breakdownExport";

const BreakdownDialog = ({ open, onClose, title, subtitle, columns, rows, exportFileName, maxTableHeight = 420 }) => {
  const hasRows = Array.isArray(rows) && rows.length > 0;
  const fileName = exportFileName || (subtitle ? `${title} - ${subtitle}` : title);
  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
        <Box sx={{ overflow: "hidden" }}>
          <Box sx={{ fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{title}</Box>
          {subtitle && (
            <Box sx={{ fontSize: 13, color: "text.secondary", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {subtitle}
            </Box>
          )}
        </Box>
        <Tooltip title="Export as Excel" arrow>
          <span>
            <Button variant="outlined" size="small" color="primary" startIcon={<SaveAltIcon fontSize="small" />} disabled={!hasRows} onClick={() => exportBreakdownRows({ rows, columns, fileName })} sx={{ flexShrink: 0 }} >
              Export
            </Button>
          </span>
        </Tooltip>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 2 }}>
        <GraphTable columns={columns} rows={rows} maxHeight={maxTableHeight} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" size="small">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default BreakdownDialog;
